<style scoped>
  .hostContainer.box {
    margin-bottom: 0.25rem;
    margin-top: 0.25rem;
  }
</style>
<template>
  <div class="columns">
    <div class="column is-12">
      <div class="div-table">
        <div class="columns is-gapless">
          <div class="column is-12 card-header has-text-centered button-tools">
            <strong>AHL Venues</strong>
            <div
              class="button is-info is-pulled-right"
              @click="addNew()"
            >
              Add new Venue &nbsp;
              <div style="border-radius: 15px;height: 16px;background-color: white;">
                <span
                  class="fas fa-plus-circle addhost"
                  style="font-weight:900; color: limegreen;position: relative;top: -4px;"
                />
              </div>
            </div>
            <toggle-button
              v-model="searchActive"
              :width="80"
              :height="30"
              :speed="480"
              :sync="true"
              :labels="{checked: 'Active', unchecked: 'Inactive'}"
              :color="{checked: '#7DCE94', unchecked: '#CCC'}"
              @change="getVenues()"
            />
          </div>
        </div>
        <div class="column is-12">
          <div
            v-if="selectedFranchise.name"
            class="field"
          >
            <div class="control is-flex">
              <label class="label mr-1">Franchise:</label>
              <div
                class="dropdown"
                :class="{'is-active': franchiseDropdown}"
              >
                <div class="dropdown-trigger">
                  <button
                    class="button is-small"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    @click="franchiseDropdown = !franchiseDropdown"
                  >
                    <span>{{ selectedFranchise.name }}</span>
                    <span class="icon is-small">
                      <i
                        class="far fa-angle-down"
                        aria-hidden="true"
                      />
                    </span>
                  </button>
                </div>
                <div
                  class="dropdown-menu"
                  role="menu"
                >
                  <div
                    v-for="franchise in franchises"
                    class="dropdown-content"
                  >
                    <a
                      class="dropdown-item"
                      @click="selectFranchise(franchise)"
                    >
                      {{ franchise.name }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div
            v-for="venue in venues"
            class="box p-1 mt-4 is-radiusless hostContainer"
          >
            <div class="border-bottom is-flex flex-row space-between relative align-center p-1">
              <div class="is-flex flex-row align-center">
                <div class="ml-4">
                  <router-link
                    :to="`/admin/venues/edit/${venue.venueid}`"
                    class="mr-1 is-size-7-touch"
                  >
                    {{ venue.name }}
                  </router-link>
                </div>
              </div>
              <div>
                <a
                  data-tooltip="Edit Venue"
                  class="btn-icon tooltip"
                  @click="editVenue(venue.venueid)"
                >
                  <i class="far fa-edit" />
                </a>
                <a
                  data-tooltip="Delete Venue"
                  class="btn-icon tooltip"
                  @click="deleteVenue(venue.venueid)"
                >
                  <i class="far fa-ban has-text-danger" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'

  export default {
    name: 'ToolsVenueList',
    props: ['token', 'user', 'loginUser'],
    data() {
      return {
        searchActive: true,
        venues: [],
        selectedFranchise: [],
        franchiseDropdown: false,
      }
    },
    mounted: function () {
      this.getFranchises()
    },
    methods: {
      create() {
      },
      selectFranchise(franchise) {
        this.selectedFranchise = franchise
        this.franchiseDropdown = false
        this.getVenues()
      },
      getFranchises() {
        this.date = ''
        this.sessions = []
        let url = `admin/tournaments/getfranchises`
        let data = {
          token: this.token
        }
        this.$axios({
          method: 'POST',
          url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.franchises = res.data
            this.selectedFranchise = res.data[0]
            this.getVenues()
          })
          .catch((error) => {
            this.$emit('message', {error: true,showDialog: true, message: error.response.data.message})
          })
      },
      getVenues() {
        let url = `admin/venues/list/` + (this.searchActive ? 1 : 0) + '/' + this.selectedFranchise.id
        let data = {
          token: this.token,
          active: this.searchActive,
        }
        this.$axios({
          method: 'POST',
          url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.venues = res.data
          })
          .catch((error) => {
            console.log(error.response)
          })
      },
      deleteVenue(venueId) {
        var self = this
        this.$dialog.confirm('Are you sure you wish to delete this venue?')
          .then(function () {
            self.doDeleteVenue(venueId)
          })
          .catch(function () {
            console.log('Clicked on cancel')
          })
      },
      doDeleteVenue(venueId) {
        let deleteUrl = `admin/venues/delete`
        let data = {
          token: this.token,
          venueId: venueId
        }
        this.$axios({
          method: 'POST',
          url: deleteUrl,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.$emit('message', {
              showDialog: true,
              error: res.data.error,
              message: res.data.message
            })
            this.getVenues()
          })
          .catch((error) => {
            console.log(error.response)
          })
      },
      addNew() {
        this.$router.push({path: '/admin/venues/add'})
      },
      editVenue(venueId) {
        this.$router.push({path: '/admin/venues/edit/' + venueId})
      }
    }
  }
</script>
